export const countries = (state) => {
    return state.countries;
};

export const locations = (state) => {
    return state.locations;
};
